/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingModelKey {
  static readonly PUBLIC_HOLIDAY = 'time-recording/model/public-holiday';
  static readonly WEEKDAY = 'time-recording/model/weekday';
  static readonly WORKING_HOURS_RECORD = 'time-recording/model/working-hours-record';
  static readonly TIME_RECORD = 'time-recording/model/time-record';
  static readonly BALANCE = 'time-recording/model/balance';
  static readonly CARRYOVER = 'time-recording/model/carryover';
  static readonly COMMENT = 'time-recording/model/comment';
  static readonly TARGET_HOURS = 'time-recording/model/target-hours';
}
